import React from 'react'
import { Route } from 'react-router-dom'

/**
 * A component that sets the HTTP status code for server-side rendering.
 * Uses React Router's staticContext to pass the status code to the server.
 * 
 * @param {Object} props
 * @param {number} props.code - The HTTP status code to set (e.g., 404, 410)
 * @param {React.ReactNode} props.children - The content to render
 */
export default function Status({ code, children }) {
  return (
    <Route
      render={({ staticContext }) => {
        // Set the status code on the staticContext (only available during SSR)
        if (staticContext) {
          staticContext.status = code
        }
        return children
      }}
    />
  )
}
